// apps/admin/src/application/staff/types.ts

export interface StaffPermissions {
  canProcessPayments: boolean;
  canVoid: boolean;
  canRefund: boolean;
  canViewSalesSummary: boolean;
  canManageStaff: boolean;
  canAccessSettings: boolean;
}

export const DEFAULT_STAFF_PERMISSIONS: StaffPermissions = {
  canProcessPayments: true,
  canVoid: false,
  canRefund: false,
  canViewSalesSummary: false,
  canManageStaff: false,
  canAccessSettings: false,
};

export const STAFF_PERMISSION_LABELS: Record<keyof StaffPermissions, string> = {
  canProcessPayments: "Process payments",
  canVoid: "Void transactions",
  canRefund: "Issue refunds",
  canViewSalesSummary: "View sales summary",
  canManageStaff: "Manage staff",
  canAccessSettings: "Access settings",
};

export interface StaffRow {
  id: string;
  name: string;
  email: string | null;
  isOwner: boolean;
  isActive: boolean;
  permissions: StaffPermissions;
}

export interface StaffCreateInput {
  name: string;
  email?: string | null;
  pin: string;
  isOwner: boolean;
  isActive: boolean;
  permissions: StaffPermissions;
}

export interface StaffUpdateInput {
  staffId: string;
  name?: string;
  email?: string | null;
  pin?: string;
  isOwner?: boolean;
  isActive?: boolean;
  permissions?: StaffPermissions;
}
